@if (!minimized) {
	<div
		class="h-100 px-xl-5"
		[class.bg-gray-100]="currentViewType === viewType.Desktop"
		[class.px-4]="currentViewType === viewType.Desktop">
		@if (mainViewer && !isContentLoading) {
			<div class="grid-catalog-container d-flex flex-column h-100" [class.vw-100]="currentViewType === viewType.Mobile">
				@if (catalogIntegrationType === CatalogIntegrationType.CatalogItemViewer) {
					<ng-content></ng-content>
				}

				<div
					[class.d-none]="
						currentViewType !== viewType.Desktop || catalogIntegrationType === CatalogIntegrationType.CatalogItemViewer
					"
					class="flex-grow-1">
					<div class="h-auto px-2 px-sm-3 px-xl-4 pt-2 pt-xl-3">
						<div class="d-flex justify-content-between">
							<app-title-viewer [showWatchlistIcon]="true"> </app-title-viewer>
						</div>
					</div>
				</div>

				<div class="h-100 w-100" [ngClass]="currentViewType === viewType.Desktop ? 'overflow-hidden' : 'scrollbox-autohover'">
					<div
						[class.scrollbox-content-autohover]="currentViewType !== viewType.Desktop"
						[class.h-100]="currentViewType === viewType.Desktop || getTabValue() !== tab.Overview"
						class="d-flex flex-column bg-white border-catalog-details">
						@if (currentViewType !== viewType.Desktop) {
							<h1 class="fw-bold lh-normal text-normal mb-0 mx-2 mx-sm-3 mobile-title-height">
								{{ mobileHeader }}
							</h1>
						}

						<!-- CSS-Grid Action Buttons -->
						<div class="flex-grow-1">
							<div class="h-auto p-2 p-sm-3 p-xl-4 pb-3 pb-xl-4">
								<app-action-buttons
									[catalogIntegration]="catalogIntegrationType"
									[catalogDetailsType]="catalogDetailsType"
									[routingParams]="currentRoutingValues"
									[isFolderCatalogItem]="isFolderCatalogItem"
									[selectedItem]="currentMainAttachment"
									[catalogDetailsType]="catalogDetailsType"
									[exportSettings]="exportSettings"
									(contactFormOpen)="openContactForm($event)">
								</app-action-buttons>
							</div>
						</div>

						<!-- CSS-Grid Details -->
						<div
							[ngClass]="currentViewType === viewType.Desktop ? 'overflow-hidden' : 'vw-100 mobile-min-height'"
							[class.detail-scroll]="getTabValue() !== tab.Overview"
							class="h-100">
							<div class="d-flex flex-column h-100 px-2 px-sm-3 px-xl-4">
								<!-- Tabreiter Anzeige -->
								<div class="flex-grow-1">
									<div class="h-auto">
										@if (currentViewType !== viewType.Desktop && !this.routingParams?.catalogItemGuid) {
											<app-mobiletabviewer
												#tabviewer
												[tabs]="tabsViewModel"
												[queryParams]="queryParams"
												[viewGroupDtos]="viewGroupDtos"></app-mobiletabviewer>
										} @else {
											<app-tabviewer
												#tabviewer
												[tabs]="tabsViewModel"
												[catalogDetailsType]="catalogDetailsType"
												[queryParams]="queryParams"
												[routingParams]="routingParams"
												[viewGroupDtos]="viewGroupDtos">
											</app-tabviewer>
										}
									</div>
								</div>
								<div
									id="catalog-tab-panel"
									role="tabpanel"
									[class.overflow-hidden]="currentViewType === viewType.Desktop"
									class="h-100 d-flex flex-column">
									@if (getTabValue() === tab.Overview && mainViewer === Viewer.HtmlViewer) {
										<!-- Ohne @defer: die Übersicht ist der Inhalt, den ein Crawler auf
										     /catalog/<key>/catalogItem/<guid> sieht. -->
										<app-overview-viewer
											[mainViewer]="mainViewer"
											[attachment]="currentMainAttachment"
											[isSearchMode]="routingParams?.view === 'search'"
											[attachments]="viewGroupItems"
											[catalogViewShowPrice]="catalogViewShowPrice" />
									}
									@if (getTabValue() !== tab.Overview) {
										<div
											id="catalog-details-scroller"
											[class.scrollbox-autohover]="currentViewType === viewType.Desktop"
											class="h-100 pt-3">
											<!--minheight muss noch nachträglich gesetzt werden damit bei ganz kleinen Höhen der Kontent nicht verloren geht-->
											<div
												[class.scrollbox-content-autohover]="currentViewType === viewType.Desktop"
												class="d-flex flex-column h-100">
												<div class="d-flex flex-column h-100">
													<div class="h-100">
														<!-- Ohne @defer: content-viewer ist die Hülle um die einzelnen
														     Viewer-Typen, die selbst weiterhin nachgeladen werden. Nur die
														     Hülle eifrig zu haben spart eine Netzrunde, ohne einen der
														     schweren Viewer (PDF, Autodesk, CADENAS) einzuziehen. -->
														<app-content-viewer
															[mainViewer]="mainViewer"
															[catalogViewService]="getCatalogViewService()"
															[catalogKey]="catalogKey"
															[catalogLanguage]="catalogLanguage"
															[catalogItemGuid]="catalogItemGuid"
															[attachment]="currentMainAttachment"
															[attachments]="viewGroupItems"
															[featureToggles]="featureToggles"
															[catalogContentViewersViewModel]="catalogContentViewersViewModel"
															[routingParams]="routingParams"
															[url]="url"
															[queryParams]="queryParams"
															[catalogDetailsType]="catalogDetailsType"
															(contactFormOpen)="openContactForm($event)">
														</app-content-viewer>
													</div>
												</div>
												@if (hasThumbnails) {
													<div class="flex-grow-1">
														@defer (on immediate) {
															<app-attachment-thumbnails
																[routingParams]="routingParams"
																[catalogDetailsType]="catalogDetailsType"
																[currentViewType]="currentViewType"
																[viewGroupItems]="viewGroupItems">
															</app-attachment-thumbnails>
														}
													</div>
												}
											</div>
										</div>
									}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		} @else {
			<lib-loading></lib-loading>
		}
	</div>
}
@if (minimized) {
	<div class="d-flex flex-column align-items-center mt-5">
		@for (link of currentTabLinks; track link.imgAlt) {
			<a
				class="btn btn-outline-light m-2 p-2"
				[routerLink]="['.']"
				[queryParams]="{ tab: ViewGroup[link.viewGroup] }"
				[queryParamsHandling]="'merge'"
				(click)="minimize.emit()"
				[ngbTooltip]="link.tooltipKey | translate"
				[attr.aria-label]="link.tooltipKey | translate"
				placement="left"
				[container]="'body'">
				<img [src]="link.imgSrc" [alt]="link.imgAlt" loading="lazy" width="24px" height="24px" />
			</a>
		}
	</div>
}
